import React from 'react';
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

import {LangController} from "../../../components/tabs/langController";
import {LB_URL_VIDEO} from "../../../components/i18n/i18n";

const ChefLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            title: '',
            shortDescription: '',
            longDescription: '',
            videoUrl: '',
        }) )
        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => {
        return (
            <Form>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label >Titulo</Label>
                            <Input type="text" name="title"
                                   placeholder="Ingrese titulo"
                                   value= { child.title }
                                   onChange={e => onInputChange(e, child.lang)}
                                   disabled={disableInputs}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        <FormGroup>
                            <Label>{LB_URL_VIDEO}</Label>
                            <Input
                                type="text"
                                name="videoUrl"
                                placeholder={LB_URL_VIDEO}
                                value= { child.videoUrl }
                                onChange={e => onInputChange(e, child.lang)}
                                disabled={disableInputs}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        <FormGroup>
                            <Label >Descripción corta</Label>
                            <Input type="textarea"
                                   name="shortDescription"
                                   placeholder="Ingrese descripción corta"
                                   value= { child.shortDescription }
                                   onChange={e => onInputChange(e, child.lang)}
                                   disabled={disableInputs}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        <FormGroup>
                            <Label >Descripción larga</Label>
                            <Input type="textarea"
                                   rows={"6"}
                                   name="longDescription"
                                   placeholder="Ingrese descripción larga"
                                   value= { child.longDescription }
                                   onChange={e => onInputChange(e, child.lang)}
                                   disabled={disableInputs}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        );
    }

    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />)
}

export default ChefLangs